import { useRef } from 'react';
import { useUnit } from 'effector-react';
import { $reportStore } from '@lib/store';
import { useOutsideClick } from '@shared/hooks';
import { FileUtils } from '@shared/utils';
import { Icon, Text } from '@shared/widgets';
import CloseIcon from '@assets/icons/close.svg';
import ConfirmIcon from '@assets/icons/confirm.svg';

interface IGeneratedModalProps {
  open: boolean;
  onClose: () => void;
}

export const GeneratedFileModal = (props: IGeneratedModalProps) => {
  const reportStore = useUnit($reportStore.store);

  const ref = useRef<HTMLDivElement>(null);

  const closeHandler = () => {
    $reportStore.events.clear();
    props.onClose();
  };

  const clickHereHandler = () => {
    if (!reportStore.data?.data) return;
    FileUtils.downloadFile(reportStore.data);
  };

  useOutsideClick(ref, closeHandler);

  if (!props.open) return null;
  return (
    <div className='bg-black bg-opacity-50 flex items-center justify-center fixed inset-0 z-[9999]'>
      <div
        ref={ref}
        className='w-full max-w-[378px] h-full max-h-[300px] py-[72px] px-[50px] bg-ice dark:bg-eerie-black flex flex-col items-center gap-6 shadow-lg relative'
      >
        <Icon
          icon={<CloseIcon />}
          className='w-8 h-8 flex items-center justify-center absolute top-6 right-6 cursor-pointer'
          onClick={closeHandler}
        />
        <Icon icon={<ConfirmIcon />} className='w-12 h-12 shrink-0 flex items-center justify-center' color='primary' />
        <div className='flex flex-col items-center gap-2'>
          <Text weight='semibold' size='2xl'>
            Generated
          </Text>
          <Text className='text-center'>
            Document downloading started automatically if it did not,{' '}
            <span className='text-primary cursor-pointer' onClick={clickHereHandler}>
              click here
            </span>
          </Text>
        </div>
      </div>
    </div>
  );
};
